//	@flow

export const SET_TOAST_MESSAGE = 'SET_TOAST_MESSAGE';

export const SET_TOAST_VISIBLE = 'SET_TOAST_VISIBLE';
